import { useState, useEffect, useRef, } from 'react'
import loadable from '@loadable/component'
import { Helmet } from "react-helmet-async"
import { arrayMoveImmutable } from 'array-move'

import type {
    TPossibleScreens,
    TUpload,
    TUploadedFile,
    TUploadingError,
    TErrorText,
    TPage,
    // TSignType,
    // TSign,
    TEraseType,
    TErase,
} from "../types"

import {
    saveThumb,
    loadThumb,
    textSign,
} from '../helpers'

import { baseURL, development, isSnap } from '../constants'

import { statOnLoad } from '../Stat'

import Wrapper from "../elements/Wrapper"
import DefaultContent, { Content, SignContent } from "../elements/Content"

import {
    Buttons,
    UploadButtons,
    CloudButtons,
    ButtonOneDrive,
    ButtonDropBox,
    ButtonGoogleDrive,

    PagePreviwButtons,
    PagePreviwButton,
} from "../elements/Buttons"

import { convert, localUpload } from "../Services"

import DropZone from "../screens/DropZone"
import { SignH1 } from "../screens/Sign"

const ErrorBlock = loadable(() => import('../elements/Errors'))
const PagesPreview = loadable(() => import('../screens/PagesPreview'))
const Preloader = loadable(() => import("../screens/Preloader"))
const Download = loadable(() => import("../screens/Download"))
const Error = loadable(() => import("../screens/Error"))
const Erase = loadable(() => import("../elements/Erase"))


const uploadedFilesT: TUploadedFile[] = []
const uploadingErrors: TUploadingError[] = []
let downloadLink: string
let defaultPagesLength: number

const DSPErase = () => {
    const [currentScreen, switchScreen] = useState<TPossibleScreens>('filespreview')
    const [progress, setProgress] = useState(0)
    const [uploadedFiles, setUploadedFiles] = useState<TUploadedFile[]>(uploadedFilesT)
    const [countUploadingErrors, setCountUploadingErrors] = useState(uploadingErrors.length)
    const [errorText, setErrorText] = useState<TErrorText>({})
    const [showErrorBlock, setShowErrorBlock] = useState(true)
    const [pages, setPages] = useState<TPage[]>([])
    const [disableButton, setDisableButton] = useState(true)

    const [prep, setPrep] = useState('Uploading File')

    const [rects, setRects] = useState<TErase[]>([])
    const [editPage, setEditPage] = useState<number | null>(null)

    const upload: TUpload = {

        action: "erase_dsp",
        allowExtantions: ['pdf'],
        convertTo: "pdf",
        maxSize: 25, // MB
        multiselect: false,

        setDownloadLink: (link: string) => downloadLink = link,
        getDownloadLink: () => downloadLink,
        setProgress: (progress) => setProgress(progress),
        getProgress: () => progress,
        setScreen: (screen) => {
            if (window.scrollY > 220) window.scrollTo({ top: 0, behavior: "smooth" })
            if (screen === 'uploading' || screen === 'converting' || screen === 'preparing') setProgress(0)
            return switchScreen(screen)
        },
        getScreen: () => currentScreen,
        addFiles: (uploadedFile) => {
            return setUploadedFiles([...uploadedFile])
        },
        delFile: (uploadedFile) => {
            return setUploadedFiles(uploadedFiles.filter((element) => element !== uploadedFile))
        },
        clearFiles: () => setUploadedFiles([]),
        getFiles: () => uploadedFiles,
        moveFiles: (oldIndex, newIndex) => {
            return setUploadedFiles(arrayMoveImmutable(uploadedFiles, oldIndex, newIndex))
        },
        addError: (uploadingError) => {
            uploadingErrors.push(uploadingError)
            setShowErrorBlock(true)
            return setCountUploadingErrors(countUploadingErrors + 1)
        },
        delError: (uploadingError) => {
            const idx = uploadingErrors.indexOf(uploadingError)
            if (idx !== -1) {
                uploadingErrors.splice(idx, 1)
                return setCountUploadingErrors(countUploadingErrors - 1)
            }
        },
        clearErrors: () => {
            uploadingErrors.splice(0, uploadingErrors.length)
            return setCountUploadingErrors(0)
        },
        hideErrors: () => setShowErrorBlock(false),
        getErrors: () => uploadingErrors,
        setErrorText: setErrorText,

        getPages: () => pages,
        setPages: (newPages) => {
            if (newPages.length != defaultPagesLength ||
                newPages.some((e, i) => {
                    return e.page_num != i || e.rotate % 360 != 0
                })) setDisableButton(false)
            else setDisableButton(true)

            return setPages(newPages)
        },
        setDefaultPages: (pages) => {
            defaultPagesLength = pages.length
            return saveThumb(pages)
        },
    }

    useEffect(() => {
        
        const token = location.hash.replace('#', '')

        if (token.includes("id=")) {
            const docid = token.slice(3);
            if (Number.isInteger(Number(docid)) && String(Number(docid)) == docid) {
                localUpload(upload, docid, true)
                setPrep('Prepairing File')
            }
        }
        else if (token.length === 36) {
            localUpload(upload, token)
            setPrep('Prepairing File')
        }
        else statOnLoad(upload)
    },[])


    // useEffect(() => {
    //     const token = location.hash.replace('#', '')
    //     if (token.length === 36) {
    //         location.hash = ''
    //         localUpload(upload, token)
    //     }
    //     else statOnLoad(upload)
    // }, [])

    return (
        <Wrapper>
            <Helmet>
                <title>Erase DSP | Templateroller</title>
                <meta name="robots" content="noindex" />
                <meta property="og:image" content={`${baseURL}/tools/assets/og-eraser.png`} />
            </Helmet>

            {   // Начальный экран
                currentScreen === 'filespreview' &&
                (uploadedFiles.length === 0 || pages.length === 0) &&
                <h1>Erase DSP</h1>
            }

            {   // Экран превью страниц
                currentScreen === 'filespreview' &&
                uploadedFiles.length > 0 &&
                pages.length > 0 &&
                <SignH1>Choose page to erase content</SignH1>
            }

            {
                currentScreen === 'filespreview' &&
                (uploadedFiles.length === 0 || pages.length === 0) &&
                <DefaultContent>
                    {
                        countUploadingErrors > 0 &&
                        showErrorBlock &&
                        <ErrorBlock upload={upload} />
                    }

                    <DropZone
                        title="Erase DSP online: drag and drop PDF file"
                        description="DSP only"
                        buttonText="Browse file"
                        warning={`Upload document of up to ${upload.maxSize} MB in ${(upload.allowExtantions.length > 2 ? upload.allowExtantions.map((e, i) => i == upload.allowExtantions.length - 1 ? `and .${e}` : `.${e}`) : upload.allowExtantions.map(e => `.${e}`)).join(', ')} format${upload.allowExtantions.length > 1 ? 's' : ''}`}

                        upload={upload}
                    />
                    <Buttons>
                        <UploadButtons>
                            <CloudButtons>
                                <ButtonDropBox upload={upload} />
                                <ButtonOneDrive upload={upload} />
                                <ButtonGoogleDrive upload={upload} />
                            </CloudButtons>
                        </UploadButtons>
                    </Buttons>

                </DefaultContent>

            }

            {
                currentScreen === 'filespreview' &&
                uploadedFiles.length > 0 &&
                pages.length > 0 &&
                <Content>
                    {
                        countUploadingErrors > 0 &&
                        showErrorBlock &&
                        <ErrorBlock upload={upload} />
                    }

                    <PagesPreview
                        upload={upload}
                        sortable={false}
                        setEditPage={setEditPage}
                        signs={rects}
                    />

                    <Erase
                        rects={rects}
                        setRects={setRects}
                        editPage={editPage}
                        setEditPage={setEditPage}
                        pages={pages}
                    />

                    <Buttons>
                        <PagePreviwButtons>
                            <PagePreviwButton
                                primary={false}
                                onClick={() => {
                                    if (rects.length === 0) {
                                        if (confirm('Do you want to upload again?')) {
                                            setUploadedFiles([])
                                            return setPages([])
                                        }
                                    }
                                    else {
                                        if (confirm('Do you want to clear all rects?')) {
                                            return setRects([])
                                        }
                                    }
                                }}
                            >{`${rects.length === 0 ? 'Reset' : 'Undo'}`}</PagePreviwButton>
                            <PagePreviwButton
                                primary={true}
                                disabled={rects.length === 0}
                                onClick={() => {
                                    return convert({
                                        upload: upload,
                                        eraseRects: rects,
                                    })
                                }}
                            >Apply</PagePreviwButton>
                        </PagePreviwButtons>
                    </Buttons>
                </Content>
            }

            {
                currentScreen === 'uploading' &&
                // signed &&
                <DefaultContent>
                    <Preloader
                        type="progress"
                        title="Uploading File"
                        description="Don’t close this tab, your files are being uploaded. This shouldn’t take long."
                        progress={progress}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'preparing' &&
                // signed &&
                <DefaultContent>
                    <Preloader
                        type="progress"
                        title="Preparing Pages"
                        description="Don’t close this tab, your files are being prepared. This won't take long."
                        progress={progress}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'converting' &&
                <DefaultContent>
                    <Preloader
                        type="progress"
                        title="Processing Document"
                        description="Don’t close this tab, your files are being processed. This won't take long."
                        progress={progress}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'link' &&
                <DefaultContent>
                    <Download
                        title="Download PDF"
                        description="Click on “Download” to save the file to your device."
                        buttonText="Download"

                        upload={upload}
                        backToScreen={'filespreview'}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'error' &&
                <DefaultContent>
                    <Error text={errorText} />
                </DefaultContent>
            }

        </Wrapper>
    )
}

export default DSPErase